import React, { useState, useEffect } from "react";
import Widgets from "../../../widgets";
import { useTranslation } from "react-i18next";
import plusIcon from "../../../Assets/Icons/PlusIcon.png";
import "./ArticleList.css";
import Icons from "../../../Assets/Icons";
import { useDispatch, useSelector } from "react-redux";
import { getAllArticle } from "../../../modules/article/ArticleThunk";
import { resetAllArticle } from "../../../modules/article/ArticleSlice";
import ToastPopup from "../../../widgets/Toast/toastPopup";
import NoData from "../../../Assets/Icons/NoData.png";
import strings from "../../../utils/strings";

const ArticleList = ({ setSelectedView, setUserId }) => {
  const dispatch = useDispatch();
  const breadcrumbs = ["healthArt"];
  const paths = [strings.navigation.healthArticle];
  const { t } = useTranslation();
  const [searchInput, setSearch] = useState(null);
  const [totalPages, setTotalPages] = useState("");
  const [articleCount, setArticleCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(null);
  const { allArticle, allArticleErr } = useSelector((state) => state.article);
  const [itemsPerPage] = useState(10);
  const [articleList, setArticleList] = useState([]);
  const selectedLanguage = useSelector((state) => state.language.language);
  const fetchAllArticle = (pageNumber, search = searchInput) => {
    const page = pageNumber ?? currentPage ?? 1;
    const limit = itemsPerPage;
    dispatch(getAllArticle({ page, limit, search }));
  };

  useEffect(() => {
    fetchAllArticle();
  }, [selectedLanguage]);

  useEffect(() => {
    if (searchInput != undefined) {
      fetchAllArticle(1);
    }
  }, [searchInput]);

  useEffect(() => {
    if (allArticleErr) {
      ToastPopup.error(allArticleErr);
    }
    if (allArticle && allArticle.status === "success") {
      setArticleCount(allArticle.data.totalArticles);
      setCurrentPage(allArticle.data.currentPage);
      setTotalPages(allArticle.data.totalPages);
      setArticleList(allArticle.data.articles);
    }
    dispatch(resetAllArticle());
  }, [allArticle, allArticleErr]);

  const handleSearch = (query) => {
    setSearch(query);
  };

  const handleClick = (pageNumber) => {
    fetchAllArticle(pageNumber);
  };

  const handlePrevNext = (direction) => {
    if (direction === "prev" && currentPage > 1) {
      fetchAllArticle(currentPage - 1);
    } else if (direction === "next" && currentPage < totalPages) {
      fetchAllArticle(currentPage + 1);
    }
  };

  const renderPagination = () => {
    const pages = [];
    if (totalPages <= 4) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 2) {
        pages.push(1, 2, { type: "ellipsis" }, totalPages);
      } else if (currentPage >= totalPages - 1) {
        pages.push(1, { type: "ellipsis" }, totalPages - 1, totalPages);
      } else {
        pages.push(1, { type: "ellipsis" }, currentPage, { type: "ellipsis" }, totalPages);
      }
    }
    return pages;
  };

  const handleButtonClick = () => {
    setSelectedView("artAdd");
  };

  function normalizeDate(date) {
    if (/\d{2}\/\d{2}\/\d{4}/.test(date)) {
      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    }
    return date;
  }

  const handleEdit = (item) => {
    setUserId(item._id);
    setSelectedView("artEdit");
  };

  return (
    <div className="department-box article-box article-list-box">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="department-heading">{t("articles")}</div>
      <div className="department-results">
        {articleCount} {t("entriesFound")}
      </div>
      <div className="department-search-line">
        <Widgets.SearchBox onSearch={handleSearch} placeholder={"searchByArticleName"} />
        <Widgets.IconButton iconSrc={plusIcon} buttonText="addHealthArticle" onClick={handleButtonClick} />
      </div>
      {articleList.length > 0 ? (
        <div className="article-array">
          {articleList.map((item) => (
            <div
              key={item._id}
              className="article-item"
              onClick={() => {
                handleEdit(item);
              }}
            >
              <div>
                <img src={item.coverImage} className="article-img" alt="Article Thumbnail" />
              </div>
              <div className="article-des">
                <p className="article-title">{item.title}</p>
                <p className="art-author">{item.category}</p>
                <p className="art-author">{item.author}</p>
                <p className="art-author">{new Date(normalizeDate(item.date)).toLocaleDateString("en-GB")}</p>
                <p className="art-author">
                  <img src={Icons.eye} alt="eye" />
                  {item.viewCount}
                </p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="no-record-container">
          <div className="no-record-icon">
            <img src={NoData} alt="No Data Found" />
          </div>
          <div className="no-record-text">{t("noRecordFound")}</div>
        </div>
      )}

      <div className="department-pagination-list">
        {totalPages > 0 && (
          <>
            <button onClick={() => handlePrevNext("prev")} disabled={currentPage === 1} className="department-pagination-prev-list">
              <img src={Icons.leftArrow} alt="<" />
            </button>
            {renderPagination().map((page, index) => (
              <button
                key={index}
                onClick={() => typeof page === "number" && handleClick(page)}
                disabled={page === currentPage || page.type === "ellipsis"}
                className={`department-pagination-btn-list ${page === currentPage ? "active-list" : ""} ${page.type === "ellipsis" ? "ellipse" : ""}`}
              >
                {typeof page === "number" ? page : <img src={Icons.extraIcon} alt="..." className="department-extra-icon" />}
              </button>
            ))}
            <button onClick={() => handlePrevNext("next")} disabled={currentPage === totalPages} className="department-pagination-next-list">
              <img src={Icons.rightArrow} alt=">" />
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ArticleList;
